import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {
  required,
  email,
  alpha
} from '../../functions/validationRules';
import ValidationInput from '../common/ValidationInput';
import Button from '../common/Button';
import { centerChildStyle } from './styles/SsoCreateForm.css';
import LwolfTooltip from '../common/LwolfTooltip';

export const SsoCreateForm = props => {
  const buttonIsDisabled = () => {
    const {
      email,
      emailMatch,
      firstName,
      lastName,
      password,
      passwordMatch
    } = props.values;

    const disabled = !(
      email.length > 0 &&
      emailMatch.length > 0 &&
      firstName.length > 0 &&
      lastName.length > 0 &&
      password.length > 0 &&
      passwordMatch.length > 0 &&
      email === emailMatch &&
      password === passwordMatch &&
      !props.fields.errors
    );
    return disabled;
  };

  const tooltipMsg = "Passwords must meet all of the following: 1. Minimum of 10 characters in length 2. Contain at least 3 of the following 4 types of characters: a. Lower case letters (a-z) b. Upper case letters (A-Z) c. Numbers (0-9) d. Special characters (e.g. !@#$%^&*) 3. At most 72 characters 4. Not more than 2 identical characters in a row (e.g. 111 not allowed)"

  return (
    <form>
      <div className="row">
        <div className="col-md-6">
          <LwolfTooltip content={'You can use any email address'}>
            <Field
              className="form-control input-lg"
              type="text"
              name="email"
              label="Email"
              component={ValidationInput}
              validate={[required, email]}
              val={props.values.email}
              matchValue={props.values.emailMatch}
              mismatchMessage={'Emails do not match'}
              otherTouched={props.fields.emailMatchTouched}
            />
          </LwolfTooltip>
        </div>
        <div className="col-md-6">
          <LwolfTooltip content={'You can use any email address'}>
            <Field
              className="form-control input-lg"
              type="text"
              name="emailMatch"
              label="Re-enter Email"
              component={ValidationInput}
              validate={[required, email]}
              val={props.values.emailMatch}
              matchValue={props.values.email}
              mismatchMessage={'Emails do not match'}
              otherTouched={props.fields.emailTouched}
            />
          </LwolfTooltip>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Field
            className="form-control input-lg"
            type="text"
            name="firstName"
            label="First Name"
            component={ValidationInput}
            validate={[required, alpha]}
          />
        </div>
        <div className="col-md-6">
          <Field
            className="form-control input-lg"
            type="text"
            name="lastName"
            label="Last Name"
            component={ValidationInput}
            validate={[required, alpha]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <LwolfTooltip content={tooltipMsg}>
            <Field
              className="form-control input-lg mb-0"
              type="password"
              name="password"
              label="Password"
              component={ValidationInput}
              validate={[required]}
              val={props.values.password}
              matchValue={props.values.passwordMatch}
              mismatchMessage={'Passwords do not match'}
              otherTouched={props.fields.passwordMatchTouched}
            />
          </LwolfTooltip>
        </div>
        <div className="col-md-6">
          <LwolfTooltip content={tooltipMsg}>
            <Field
              className="form-control input-lg"
              type="password"
              name="passwordMatch"
              label="Re-enter Password"
              component={ValidationInput}
              validate={[required]}
              val={props.values.passwordMatch}
              matchValue={props.values.password}
              mismatchMessage={'Passwords do not match'}
              otherTouched={props.fields.passwordTouched}
            />
          </LwolfTooltip>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={centerChildStyle}>
          {props.apiError}
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={centerChildStyle}>
          <Button
            classNames={["btn-lg"]}
            action={props.handleSubmit}
            disabled={buttonIsDisabled()}
            text="Create Account"
          />
        </div>
      </div>
    </form>
  );
};

export const mapStateToProps = state => {
  let values2 = {
    email: '',
    emailMatch: '',
    firstName: '',
    lastName: '',
    password: '',
    passwordMatch: ''
  };

  let fields2 = {
    emailTouched: false,
    emailMatchTouched: false,
    passwordTouched: false,
    passwordMatchTouched: false,
    errors: true
  };

  if (state.form.SsoCreate) {
    const { values, fields } = state.form.SsoCreate;

    if (values) {
      values2 = {
        email: values.email || '',
        emailMatch: values.emailMatch || '',
        firstName: values.firstName || '',
        lastName: values.lastName || '',
        password: values.password || '',
        passwordMatch: values.passwordMatch || ''
      };
    }
    if (fields) {
      fields2 = {
        emailTouched: fields.email && fields.email.touched ? true : false,
        emailMatchTouched:
          fields.emailMatch && fields.emailMatch.touched ? true : false,
        passwordTouched:
          fields.password && fields.password.touched ? true : false,
        passwordMatchTouched:
          fields.passwordMatch && fields.passwordMatch.touched ? true : false,
        errors: state.form.SsoCreate.syncErrors ? true : false
      };
    }
  }

  return {
    values: values2,
    fields: fields2
  };
};

const mapDispatchToProps = dispatch => ({});

export default reduxForm({
  form: 'SsoCreate'
})(connect(mapStateToProps, mapDispatchToProps)(SsoCreateForm));
